export default __webpack_public_path__ + "static/architecture-b9164ffe47e54470d33517c4fd0e4165.png";